# ---
# Если элемент скроллится вертикально, то возвращает количество страниц,
# до которых осталось доскроллить
# Удобно для реализации логики подгрузки по скроллу в списке
# ---
module.exports = (el) ->
  $el = $( el )

  # Сколько осталось до конца
  remainingHeight = el.scrollHeight - $el.height() - $el.scrollTop()
  # Сколько уже проскроллили
  scrolled = el.scrollHeight - $el.height()
  # Сколько страниц осталось
  remainingPages = remainingHeight / $el.height()
